// extracted by mini-css-extract-plugin
module.exports = {"declaration":"wNr2phmrVi8j1MA7k89YgA==","footer":"ORnA1u6nv-EYJg0ME5Sqwg=="};